import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"   viewBox="0 0 282.000000 286.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,286.000000) scale(0.100000,-0.100000)">


<path d="M702 2853 c390 -2 1026 -2 1415 0 390 1 71 2 -707 2 -778 0 -1097 -1
-708 -2z"/>
<path d="M1994 2572 c4 -7 1 -12 -8 -12 -9 0 -16 -4 -16 -9 0 -5 23 -12 51
-16 117 -16 230 -108 261 -212 10 -34 17 -43 35 -43 18 0 23 5 23 28 -1 72
-94 194 -184 239 -54 27 -175 46 -162 25z"/>
<path d="M989 2513 c-1 -5 -1 -12 0 -17 1 -5 -9 -6 -23 -4 -14 3 -23 1 -20 -4
8 -12 -19 -36 -48 -43 -20 -5 -24 -12 -22 -32 2 -19 0 -23 -9 -14 -8 8 -15 3
-27 -21 -21 -42 -148 -286 -211 -404 -27 -50 -49 -94 -49 -98 0 -18 133 7 233
44 49 18 59 27 75 63 56 125 136 287 140 282 5 -4 86 -181 102 -222 l9 -21 63
18 c35 10 89 26 120 34 l58 16 -108 215 -107 215 -87 0 c-49 0 -89 -3 -89 -7z"/>
<path d="M1662 2497 c-12 -14 -191 -380 -188 -384 1 -1 59 13 130 30 125 32
128 33 143 67 l15 35 10 -27 c5 -16 16 -28 24 -28 17 0 198 31 202 34 4 5
-120 271 -130 277 -6 4 -52 7 -102 8 -68 1 -96 -2 -104 -12z"/>
<path d="M1983 2459 c4 -13 7 -27 7 -31 0 -5 11 -8 25 -8 61 0 156 -75 171
-135 4 -18 13 -25 30 -25 66 0 -15 143 -108 191 -21 11 -59 22 -85 26 -45 6
-46 6 -40 -18z"/>
<path d="M2008 2344 c2 -14 12 -28 21 -31 24 -9 61 -45 61 -60 0 -7 4 -13 9
-13 20 0 41 13 41 25 0 20 -48 74 -81 90 -43 23 -57 19 -51 -11z"/>
<path d="M1973 2179 c-229 -27 -591 -119 -1034 -264 -321 -105 -419 -117 -419
-52 0 24 45 103 84 146 37 42 -65 -32 -120 -86 -88 -88 -105 -179 -46 -236 36
-34 73 -47 136 -47 77 0 137 21 386 137 302 141 457 205 630 263 294 98 524
131 587 84 35 -26 40 -64 15 -114 -24 -48 -7 -42 35 13 45 60 50 88 21 121
-37 42 -121 53 -275 35z"/>
<path d="M1940 2089 c-52 -11 -97 -22 -99 -25 -5 -4 9 -47 47 -151 3 -10 -22
-13 -107 -13 l-110 0 -36 -76 c-19 -42 -35 -81 -35 -85 0 -5 79 -10 176 -11
l177 -3 30 -78 30 -78 134 2 c73 0 135 5 138 9 7 11 -228 523 -240 526 -6 1
-53 -6 -105 -17z"/>
<path d="M1560 1979 c-168 -58 -350 -132 -350 -143 0 -6 20 -67 44 -136 l44
-125 96 1 c53 0 98 3 102 6 5 6 174 417 174 425 0 7 -29 0 -110 -28z"/>
<path d="M695 1615 l-80 -34 72 -1 c70 0 73 1 88 30 26 50 27 50 -80 5z"/>
<path d="M291 1506 c-80 -27 -140 -108 -141 -192 0 -53 41 -133 82 -161 115
-77 275 -37 329 82 10 22 19 55 19 73 l0 32 -111 0 -110 0 3 -37 c3 -36 5 -38
42 -43 l38 -5 -21 -19 c-25 -23 -83 -25 -108 -4 -9 7 -22 28 -30 46 -16 39 -5
88 27 117 27 25 87 21 115 -5 21 -20 25 -20 71 -7 26 7 49 18 51 24 6 17 -37
63 -79 84 -52 26 -122 32 -177 15z"/>
<path d="M553 1493 c2 -10 29 -96 58 -191 l54 -172 64 2 63 3 28 78 c15 43 29
80 32 82 2 2 16 -34 32 -80 l27 -85 62 0 62 0 68 183 c37 100 67 185 67 190 0
4 -26 7 -59 7 l-58 0 -33 -85 c-18 -47 -36 -88 -40 -90 -4 -3 -20 35 -36 83
l-30 87 -54 3 -55 3 -34 -97 c-39 -109 -34 -110 -80 29 l-23 67 -60 0 c-53 0
-60 -2 -55 -17z"/>
<path d="M1229 1463 c-63 -143 -122 -281 -130 -300 -8 -22 -7 -23 55 -23 62 0
64 1 75 30 10 29 11 30 80 30 68 0 69 -1 80 -30 l10 -30 130 0 130 0 3 63 3
62 43 -62 43 -63 70 0 71 0 -23 38 c-12 20 -31 49 -41 64 -18 26 -18 26 12 56
25 26 30 38 30 79 0 99 -57 132 -227 133 l-113 0 0 -177 0 -178 -66 155 c-36
85 -68 162 -71 172 -6 20 -33 28 -96 28 -47 0 -48 0 -68 -47z m520 -67 c18
-21 2 -45 -35 -52 -47 -9 -59 -2 -62 35 -2 30 -1 31 42 31 25 0 48 -6 55 -14z
m-399 -103 c0 -2 -16 -3 -35 -3 -40 0 -40 0 -18 58 l16 44 19 -49 c10 -26 18
-49 18 -50z"/>
<path d="M1910 1465 l0 -44 75 -3 75 -3 -75 -94 c-68 -84 -75 -98 -75 -137 l0
-44 160 0 c88 0 160 4 160 9 0 5 -7 25 -15 45 l-15 36 -75 0 c-41 0 -75 3 -75
8 1 4 41 54 90 112 65 76 90 112 90 133 l0 27 -160 0 -160 0 0 -45z"/>
<path d="M2335 1493 c-74 -39 -114 -105 -115 -189 0 -161 181 -257 316 -167
34 22 124 129 124 148 0 4 -21 -11 -46 -34 -71 -62 -127 -86 -205 -86 -80 0
-100 14 -125 87 -20 62 -12 108 27 153 36 41 86 59 145 52 85 -9 129 -66 122
-159 -1 -26 0 -48 3 -48 3 0 18 13 33 29 24 25 27 35 22 64 -11 57 -59 122
-108 146 -54 26 -148 28 -193 4z"/>
<path d="M2487 1413 c-8 -8 -9 -213 -1 -213 3 0 14 5 25 10 17 9 19 22 19 98
0 55 -4 92 -12 100 -14 14 -22 15 -31 5z"/>
<path d="M2400 1264 c0 -83 1 -85 23 -82 20 3 22 9 25 86 3 82 3 82 -23 82
-25 0 -25 -1 -25 -86z"/>
<path d="M2324 1266 c-8 -34 -2 -57 18 -70 26 -16 38 3 31 52 -4 32 -10 42
-24 42 -11 0 -21 -10 -25 -24z"/>
<path d="M740 970 c0 -89 3 -120 13 -121 6 -1 48 -3 92 -5 159 -6 235 32 235
119 0 30 -7 53 -22 72 -34 44 -75 55 -203 55 l-115 0 0 -120z m228 44 c26 -18
29 -60 5 -86 -12 -14 -31 -18 -80 -18 l-63 0 0 60 0 60 58 0 c36 0 66 -6 80
-16z"/>
<path d="M1161 976 c-34 -63 -61 -117 -61 -120 0 -3 22 -6 49 -6 41 0 51 4 56
20 3 11 12 20 20 20 7 0 12 8 11 18 -1 13 5 16 24 14 14 -2 26 -8 28 -12 2 -5
10 -6 19 -3 11 4 14 2 9 -5 -4 -7 -3 -12 3 -12 5 0 13 5 16 10 4 7 13 6 26 -1
12 -6 23 -8 26 -5 3 2 16 0 30 -5 23 -9 22 -4 -23 78 -71 132 -62 123 -121
123 l-51 0 -61 -114z m134 18 c8 -20 15 -38 15 -40 0 -2 -16 -4 -35 -4 -19 0
-35 2 -35 5 0 7 33 75 37 75 1 0 10 -16 18 -36z"/>
<path d="M1430 1060 c0 -29 1 -30 50 -30 l50 0 0 -44 c0 -24 3 -64 6 -90 7
-46 7 -46 45 -46 l39 0 0 90 0 90 55 0 c54 0 55 0 55 30 l0 30 -150 0 -150 0
0 -30z"/>
<path d="M1833 1078 c-11 -15 -123 -224 -123 -230 0 -7 72 -9 91 -3 9 3 19 15
22 25 4 17 14 20 69 20 59 0 66 -2 76 -25 10 -21 18 -25 57 -25 29 0 45 4 45
13 0 6 -29 62 -63 122 l-62 110 -51 3 c-33 2 -54 -2 -61 -10z m64 -126 c-16
-2 -31 -2 -33 1 -2 2 3 21 12 42 l16 39 17 -40 18 -39 -30 -3z"/>
<path d="M417 970 c-114 -4 -210 -9 -212 -12 -6 -5 256 -18 377 -18 71 0 78 2
78 20 0 13 -6 19 -17 18 -10 -1 -111 -4 -226 -8z"/>
<path d="M2133 956 c0 -6 14 -10 31 -10 17 1 123 3 236 4 160 2 192 4 145 11
-88 13 -412 9 -412 -5z"/>
<path d="M465 770 c-9 -14 3 -30 23 -31 10 -1 7 -4 -8 -9 -22 -6 -23 -8 -7
-15 12 -5 24 -2 34 8 14 14 13 16 -8 28 -23 12 -23 12 -4 20 19 7 19 8 -2 8
-12 1 -25 -3 -28 -9z"/>
<path d="M550 761 c-14 -28 -12 -41 5 -35 8 4 22 1 30 -6 18 -15 18 -12 4 29
-13 36 -24 39 -39 12z m25 -11 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10
4 10 3 0 8 -4 11 -10z"/>
<path d="M626 771 c-6 -9 0 -51 9 -59 3 -3 5 11 5 31 0 37 -4 45 -14 28z"/>
<path d="M670 745 c0 -28 4 -35 19 -35 11 0 27 7 35 16 22 21 4 54 -29 54 -22
0 -25 -4 -25 -35z m48 2 c2 -10 -3 -17 -11 -17 -16 0 -30 24 -19 34 10 10 27
1 30 -17z"/>
<path d="M770 761 c-5 -11 -10 -28 -10 -38 0 -15 2 -16 10 -3 8 12 13 13 30 2
23 -14 23 -14 9 27 -13 36 -24 39 -39 12z"/>
<path d="M887 767 c-17 -44 13 -69 48 -43 16 12 18 18 9 33 -14 23 -50 29 -57
10z m43 -17 c0 -11 -7 -20 -15 -20 -8 0 -15 9 -15 20 0 11 7 20 15 20 8 0 15
-9 15 -20z"/>
<path d="M981 749 c-14 -41 -14 -41 9 -27 17 11 22 10 30 -2 13 -20 13 1 0 34
-13 35 -26 33 -39 -5z"/>
<path d="M1058 773 c6 -2 12 -18 12 -34 0 -18 4 -28 10 -24 6 3 10 17 10 30 0
13 6 26 13 28 6 3 -4 5 -23 5 -19 0 -29 -2 -22 -5z"/>
<path d="M1131 749 c-14 -41 -14 -41 8 -27 15 9 23 9 35 -1 20 -17 20 -8 1 29
-20 38 -30 38 -44 -1z"/>
<path d="M1250 745 c0 -28 4 -35 19 -35 11 0 27 7 35 16 22 21 4 54 -29 54
-22 0 -25 -4 -25 -35z m48 2 c2 -10 -3 -17 -12 -17 -10 0 -16 9 -16 21 0 24
23 21 28 -4z"/>
<path d="M1380 743 c1 -33 2 -36 14 -21 12 16 14 16 30 0 17 -16 18 -16 6 6
-9 18 -9 27 1 38 14 17 -2 19 -19 2 -9 -9 -12 -9 -12 0 0 7 -4 12 -10 12 -5 0
-10 -17 -10 -37z"/>
<path d="M1460 756 c0 -29 22 -49 44 -40 10 4 16 17 15 38 -1 28 -2 29 -8 7
-9 -34 -31 -39 -31 -7 0 14 -4 26 -10 26 -5 0 -10 -11 -10 -24z"/>
<path d="M1551 743 c1 -21 3 -30 6 -20 4 14 8 16 19 6 11 -9 15 -7 21 7 6 17
8 16 14 -6 6 -21 7 -18 8 15 l0 40 -19 -23 c-18 -22 -19 -22 -25 -2 -11 33
-25 23 -24 -17z"/>
<path d="M1662 755 c-15 -31 -16 -56 -2 -35 8 12 13 13 30 2 11 -7 20 -8 20
-3 0 16 -22 61 -30 61 -4 0 -12 -11 -18 -25z m23 -5 c3 -5 1 -10 -4 -10 -6 0
-11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z"/>
<path d="M1777 773 c-12 -19 11 -65 31 -61 12 2 17 13 18 38 1 26 1 28 -3 8
-2 -16 -10 -28 -18 -28 -8 0 -15 12 -17 28 -2 16 -6 22 -11 15z"/>
<path d="M1860 751 c0 -17 5 -33 10 -36 6 -3 10 4 10 16 0 21 0 21 20 -2 l19
-24 0 40 c0 27 -3 34 -8 22 -6 -17 -8 -17 -20 -3 -20 24 -31 19 -31 -13z"/>
<path d="M1950 751 c0 -17 5 -33 10 -36 6 -4 10 8 10 29 0 20 -4 36 -10 36 -5
0 -10 -13 -10 -29z"/>
<path d="M1998 773 c6 -2 12 -18 12 -34 0 -18 4 -28 10 -24 6 3 10 17 10 30 0
13 6 26 13 28 6 3 -4 5 -23 5 -19 0 -29 -2 -22 -5z"/>
<path d="M2110 745 c0 -27 4 -35 18 -35 29 0 40 14 35 43 -4 20 -11 27 -29 27
-21 0 -24 -5 -24 -35z m40 15 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5
10 10 10 6 0 10 -4 10 -10z m-3 -26 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1
17 -2 13 -5z"/>
<path d="M2190 751 c0 -17 5 -33 10 -36 6 -4 10 8 10 29 0 20 -4 36 -10 36 -5
0 -10 -13 -10 -29z"/>
<path d="M2241 748 c-1 -32 2 -38 19 -38 11 0 20 5 20 10 0 6 -6 10 -14 10 -8
0 -17 12 -19 28 -3 22 -4 20 -6 -10z"/>
<path d="M2311 748 c-1 -32 2 -38 19 -38 11 0 20 5 20 10 0 6 -6 10 -14 10 -8
0 -17 12 -19 28 -3 22 -4 20 -6 -10z"/>
<path d="M169 621 c-33 -34 -38 -75 -14 -121 22 -42 67 -52 222 -48 122 3 133
5 156 26 32 31 41 65 27 108 -19 55 -48 64 -215 64 l-147 0 -29 -29z m144 -9
c9 -10 19 -32 23 -48 8 -42 -35 -94 -77 -94 -67 0 -104 89 -59 138 26 28 90
30 113 4z m98 -59 c1 -17 2 -17 6 0 4 14 23 25 23 13 0 -2 3 -11 6 -20 5 -13
-2 -16 -35 -16 -34 0 -41 3 -41 20 0 26 39 28 41 3z m62 -3 c-3 -11 -7 -20 -8
-20 -1 0 -5 9 -8 20 -3 12 0 20 8 20 8 0 11 -8 8 -20z m40 0 c4 -15 0 -20 -14
-20 -21 0 -22 1 -13 24 8 22 21 20 27 -4z"/>
<path d="M260 600 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"/>
<path d="M196 575 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M300 576 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M230 570 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M260 570 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z"/>
<path d="M192 538 c2 -6 10 -14 16 -16 7 -2 10 2 6 12 -7 18 -28 22 -22 4z"/>
<path d="M230 540 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M260 540 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z"/>
<path d="M306 541 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M260 499 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M649 621 c-33 -33 -38 -75 -14 -120 23 -46 55 -53 235 -49 l162 3 24
28 c35 41 33 99 -5 138 l-29 29 -172 0 -172 0 -29 -29z m54 -35 c-3 -40 14
-68 36 -61 23 7 49 -21 33 -37 -32 -32 -123 62 -107 112 10 32 40 21 38 -14z
m147 -42 c0 -8 -7 -14 -15 -14 -17 0 -18 2 -9 24 7 18 24 12 24 -10z m17 -6
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m65 9 c-4 -15 -7 -17
-11 -6 -3 7 -11 15 -18 16 -7 2 -10 -4 -7 -12 4 -8 1 -15 -5 -15 -6 0 -11 8
-11 18 0 14 8 19 29 20 25 0 28 -2 23 -21z m44 12 c4 -8 9 -7 15 2 6 10 9 8 9
-7 0 -16 -6 -21 -25 -21 -18 0 -25 5 -25 18 0 21 15 25 26 8z m56 4 c-6 -2
-10 -9 -7 -13 3 -5 1 -11 -5 -15 -5 -3 -10 3 -10 14 0 14 6 21 18 20 10 0 12
-3 4 -6z"/>
<path d="M1169 621 c-47 -47 -36 -126 21 -156 26 -14 60 -16 200 -13 161 3
169 4 194 27 14 13 28 36 31 52 8 37 -18 93 -51 108 -16 7 -89 11 -195 11
l-171 0 -29 -29z m111 5 c0 -3 -4 -16 -10 -30 -8 -21 -6 -26 6 -26 10 0 5 -13
-18 -45 -37 -50 -52 -58 -38 -19 13 33 13 34 -5 34 -19 0 -19 3 5 50 13 26 27
40 40 40 11 0 20 -2 20 -4z m91 -43 c1 -17 2 -17 6 0 4 15 16 17 102 16 93 -2
98 -3 93 -23 -5 -19 -6 -19 -13 0 -7 19 -8 19 -9 -1 l-1 -20 -9 20 c-7 15 -9
16 -9 4 -1 -23 -91 -26 -91 -4 0 8 -5 15 -11 15 -6 0 -9 -7 -5 -15 4 -12 -4
-15 -39 -15 -38 0 -45 3 -45 20 0 25 30 27 31 3z m29 -58 c0 -21 20 -19 21 3
1 16 2 16 6 0 2 -10 11 -18 18 -18 9 0 12 6 9 15 -4 8 -1 15 5 15 6 0 11 -9
11 -20 0 -18 -6 -20 -65 -18 -56 1 -65 4 -65 20 0 13 8 18 30 18 20 0 30 -5
30 -15z"/>
<path d="M1500 580 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1713 632 c-54 -41 -50 -131 6 -165 25 -14 57 -17 209 -17 100 0 192
4 206 10 60 22 72 128 19 170 -24 19 -39 20 -222 20 -170 0 -199 -3 -218 -18z
m91 -27 c-5 -11 1 -15 20 -15 24 0 26 -3 26 -45 0 -41 -2 -45 -25 -45 -14 0
-25 -4 -25 -10 0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -17
0 -20 7 -20 45 0 40 2 45 23 45 13 0 32 7 43 15 24 18 25 18 18 0z m110 -13
c-6 -4 -14 -14 -17 -22 -4 -10 -6 -8 -6 8 -1 15 5 22 17 22 10 0 13 -3 6 -8z
m17 -19 c-12 -20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m-34 -65
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m50 14 c0 -10 -8 -18
-17 -18 -11 0 -15 6 -12 18 2 10 10 18 18 18 7 0 12 -8 11 -18z m33 6 c0 14
36 17 45 3 7 -12 -9 -22 -39 -25 -16 -2 -22 3 -24 18 -1 17 1 18 8 6 7 -10 10
-11 10 -2z m99 9 c-2 -1 -12 -9 -21 -16 -15 -12 -18 -11 -18 3 0 10 8 16 22
16 12 0 19 -1 17 -3z m60 -11 c9 -11 6 -15 -13 -18 -18 -4 -23 -1 -18 10 4 11
1 13 -8 7 -9 -5 -11 -4 -6 3 10 16 31 15 45 -2z"/>
<path d="M1732 548 c3 -31 6 -33 46 -36 l42 -3 0 35 c0 36 0 36 -46 36 -45 0
-45 0 -42 -32z"/>
<path d="M1990 520 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M2288 634 c-40 -21 -56 -80 -34 -126 9 -19 28 -40 42 -47 34 -15 295
-15 329 1 29 13 55 55 55 88 0 33 -26 75 -55 88 -40 18 -302 15 -337 -4z m103
-32 c20 -24 30 -61 23 -89 -6 -21 -12 -23 -65 -23 l-59 0 0 48 c0 45 3 50 33
65 42 21 50 21 68 -1z m99 -15 c0 -8 3 -8 9 1 7 11 11 11 24 -2 20 -21 27 -20
28 2 1 16 2 16 6 0 5 -22 23 -24 23 -3 0 8 9 15 20 15 14 0 20 -6 19 -22 -1
-17 -2 -19 -6 -5 -2 9 -9 17 -15 17 -5 0 -7 -7 -4 -15 5 -13 -5 -15 -67 -13
-55 2 -72 7 -75 18 -1 10 5 16 18 17 11 1 20 -4 20 -10z m10 -67 c0 -11 -4
-20 -10 -20 -5 0 -10 8 -10 17 0 15 -2 14 -15 -3 -14 -19 -14 -18 -15 4 0 17
6 22 25 22 18 0 25 -5 25 -20z m128 9 c-10 -7 -10 -9 0 -9 6 0 12 -4 12 -9 0
-5 -22 -9 -50 -8 -38 1 -50 5 -51 16 -1 13 -2 12 -6 -1 -6 -24 -23 -23 -23 1
0 17 8 19 66 19 40 0 61 -4 52 -9z"/>
<path d="M2213 555 c0 -38 2 -53 4 -32 2 20 2 52 0 70 -2 17 -4 1 -4 -38z"/>
<path d="M593 550 c0 -36 2 -50 4 -32 2 17 2 47 0 65 -2 17 -4 3 -4 -33z"/>
<path d="M1841 324 c-17 -36 -31 -69 -31 -73 1 -8 39 63 57 107 24 58 6 34
-26 -34z"/>
<path d="M1898 383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1825 370 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M2179 363 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M670 336 c-11 -19 -26 -37 -33 -40 -9 -3 -9 -5 1 -5 10 -1 10 -6 2
-22 -6 -11 -9 -25 -7 -32 2 -7 9 5 16 26 7 20 17 37 22 37 5 0 8 3 7 8 -4 16
14 51 30 55 15 4 16 5 0 6 -9 0 -26 -14 -38 -33z"/>
<path d="M1143 358 c-16 -27 -53 -111 -53 -121 1 -7 10 6 22 28 21 38 22 39
28 16 3 -14 11 -26 18 -27 7 -1 8 0 2 3 -13 6 -13 36 1 50 9 9 6 10 -11 6 -22
-6 -22 -5 -6 26 16 30 15 44 -1 19z"/>
<path d="M1281 349 c-7 -12 -10 -23 -8 -26 3 -3 11 5 17 17 6 12 10 23 8 25
-2 2 -10 -5 -17 -16z"/>
<path d="M648 353 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1194 338 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"/>
<path d="M1475 330 c-8 -16 -15 -37 -14 -47 0 -12 3 -9 8 8 5 14 14 35 20 47
6 12 9 22 7 22 -3 0 -12 -13 -21 -30z"/>
<path d="M833 338 c-9 -11 -33 -74 -33 -84 0 -2 5 -4 11 -4 5 0 8 4 5 8 -2 4
4 27 14 50 19 43 20 52 3 30z"/>
<path d="M1405 320 c-19 -37 -19 -46 0 -30 9 7 13 15 11 18 -3 2 -1 13 5 23 5
11 7 19 5 19 -3 0 -12 -13 -21 -30z"/>
<path d="M2045 339 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M2150 311 c-7 -17 -10 -36 -7 -43 3 -7 6 -4 6 7 1 11 8 31 17 43 8
12 11 22 6 22 -5 0 -15 -13 -22 -29z"/>
<path d="M1210 301 c-7 -15 -7 -22 2 -27 7 -4 10 -4 6 1 -4 4 -3 16 3 26 5 11
7 19 5 19 -3 0 -10 -9 -16 -19z"/>
<path d="M1336 301 c-11 -13 -14 -21 -7 -26 6 -3 11 2 11 12 1 17 2 17 15 -1
15 -19 15 -19 15 1 0 30 -14 36 -34 14z"/>
<path d="M1507 313 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M1924 305 c-3 -8 -4 -20 -2 -27 3 -7 7 -1 10 15 6 29 1 36 -8 12z"/>
<path d="M1954 305 c-3 -8 -4 -20 -2 -27 3 -7 7 -1 10 15 6 29 1 36 -8 12z"/>
<path d="M1992 296 c1 -14 5 -23 9 -20 7 4 0 44 -7 44 -2 0 -3 -11 -2 -24z"/>
<path d="M2070 305 c-11 -13 -11 -18 0 -28 10 -9 11 -9 6 1 -4 7 -2 19 4 27 7
8 10 15 7 15 -2 0 -10 -7 -17 -15z"/>
<path d="M2120 305 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M711 297 c-6 -6 -11 -15 -11 -21 0 -5 7 -1 15 10 13 17 14 17 15 2 0
-23 16 -31 16 -8 0 23 -19 33 -35 17z"/>
<path d="M1257 303 c-4 -3 -7 -13 -7 -22 1 -13 3 -13 11 2 11 19 8 33 -4 20z"/>
<path d="M1297 303 c-10 -9 -9 -33 1 -33 4 0 8 9 8 20 0 23 0 22 -9 13z"/>
<path d="M1665 300 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M1866 295 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M2027 303 c-9 -9 -9 -43 1 -43 4 0 8 11 8 25 2 27 1 29 -9 18z"/>
<path d="M777 279 c4 -13 8 -18 11 -10 2 7 -1 18 -6 23 -8 8 -9 4 -5 -13z"/>
<path d="M970 290 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1420 278 c-12 -22 -12 -22 6 -6 10 10 15 20 12 24 -4 3 -12 -5 -18
-18z"/>
<path d="M1305 219 c-49 -5 -112 -13 -140 -19 l-50 -9 55 4 c307 27 478 29
665 10 47 -4 48 -4 15 6 -47 14 -433 20 -545 8z"/>
<path d="M1035 180 c-27 -7 -27 -8 -5 -8 14 0 39 4 55 8 27 7 27 8 5 8 -14 0
-38 -4 -55 -8z"/>
<path d="M978 163 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
